<template>
    <div class="uplimit-step-view">
        <div class="row align-items-center mb-2 px-2">
            <div class="d-flex flex-wrap align-items-center w-100">
                <div class="control-item">
                    <b-form-datepicker id="datepicker" size="sm" :date-disabled-fn="dateDisabled" @context="onDatePicked" v-model="date1" today-button close-button locale="zh"></b-form-datepicker>
                </div>
                <div class="control-item">
                    <b-form-select size="sm" v-model="show_top_n" :options="topNOptions"></b-form-select>
                </div>
                <div class="control-item">
                    <b-form-checkbox id="checkbox_show_up_success" v-model.number="status_only_up_success" value="1" unchecked-value="0" size="sm" @click="click_show_up_success">只要晋级</b-form-checkbox>
                </div>
                <div class="control-item">
                    <b-form-checkbox id="checkbox_show_promotion_rate" v-model.number="show_promotion_rate" value="1" unchecked-value="0" size="sm">晋级率</b-form-checkbox>
                </div>
                <div class="control-item">
                    <b-form-checkbox id="checkbox_show_min_chart" v-model.number="show_min_chart" value="1" unchecked-value="0" size="sm">分时</b-form-checkbox>
                </div>
            </div>
        </div>

        <div class="ladder-scroll-wrapper">
            <div class="ladder-grid" :style="{ minWidth: (plates.length * 110 + 90) + 'px' }">
                <div class="row no-gutters flex-nowrap">
                    <div class="ladder-header-col border alert-primary d-flex align-items-center justify-content-center text-center">梯队 / 板块</div>
                    <div class="col alert-danger border py-1 px-1 text-center d-flex align-items-center justify-content-center" v-bind:key="plate.index" v-for="plate in plates">
                        <span class="plate-name-badge">{{plate['name']}}</span>
                    </div>
                </div>

                <div class="row no-gutters flex-nowrap" v-bind:key="ban.index" v-for="ban in bans">
                    <div v-if="ban==0" class="ladder-header-col border alert-danger d-flex flex-column align-items-center justify-content-center py-1">
                        <div class="ban-row">
                            <span class="ban-number">炸板</span>
                            <span v-if="show_promotion_rate" class="small-count ml-1">{{ getBanPromotionStat(ban) }}</span>
                        </div>
                    </div>
                    <div v-else class="ladder-header-col border alert-danger d-flex flex-column align-items-center justify-content-center py-1">
                        <div class="ban-row">
                            <span class="ban-number">{{ban}}板</span>
                            <span v-if="show_promotion_rate" class="small-count ml-1">{{ getBanPromotionStat(ban) }}</span>
                        </div>
                    </div>
                    
                    <div class="col border ladder-content-cell" v-bind:key="plate.index" v-for="plate in plates">
                        <div class="stock_item_block" v-bind:key="stock.index" v-for="stock in stocks_plate[ban][plate['code']]">
                            <StockTextNextDayItem @show_sidebar="show_sidebar" :only_up_success="status_only_up_success" :stock_info="stock"></StockTextNextDayItem>
                            <div v-if="show_min_chart" :data-stock-code="stock.stock_code" class="uplimit-min-chart-placeholder border-bottom">
                                <StockMiniTrend v-if="visibleStocks[stock.stock_code]" :symbol_code="stock.stock_code" :selected_date="getNextTradingDay(date1)" :key="stock.stock_code" chart_heigh="50px"></StockMiniTrend>
                                <div v-else class="mini-chart-loading">
                                    <span>载入中...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import StockTextNextDayItem from 'components/stock/StockTextNextDayItem.vue'
    import StockMiniTrend from 'components/stock/StockMiniTrend.vue'
    import { request_zzquant, request_zrx } from "network/request.js"
    
    export default {
        props: {},
        components: {
            StockTextNextDayItem,
            StockMiniTrend
        },
        mounted() {
            request_zrx({url:'/open/tradedays'}).then(res => {
                let days = res['data']['data']
                this.all_trading_days = days;
                this.last_trade_day = days[days.length-1];
                this.date1 = days[days.length-2];
                const savedShowTopN = localStorage.getItem('uplimit_show_top_n');
                if (savedShowTopN !== null) this.show_top_n = parseInt(savedShowTopN);
                const savedShowPromotionRate = localStorage.getItem('uplimit_show_promotion_rate_nextday');
                if (savedShowPromotionRate !== null) this.show_promotion_rate = parseInt(savedShowPromotionRate);
                this.update_info(this.date1);
            });
        },
        beforeDestroy() {
            if (this.observer) this.observer.disconnect();
        },
        watch: {
            show_top_n(newVal) {
                localStorage.setItem('uplimit_show_top_n', newVal);
                this.update_info(this.date1);
            },
            show_promotion_rate(newVal) {
                localStorage.setItem('uplimit_show_promotion_rate_nextday', newVal);
            },
            show_min_chart(val) {
                if (val) this.initObserver();
                else {
                    if (this.observer) {
                        this.observer.disconnect();
                        this.observer = null;
                    }
                    this.visibleStocks = {};
                }
            },
            stocks_plate: {
                handler() {
                    if (this.show_min_chart) this.observeStockRows();
                },
                deep: true
            }
        },
        data() {
            const now = new Date();
            const today = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate();
            return {
                show_min_chart: 0,
                visibleStocks: {},
                observer: null,
                status_only_up_success: 0,
                date1: today,
                last_trade_day: '',
                all_trading_days: [],
                show_top_n: 12,
                topNOptions: [
                    { value: 5, text: '显示板块: 5个' },
                    { value: 8, text: '显示板块: 8个' },
                    { value: 10, text: '显示板块: 10个' },
                    { value: 12, text: '显示板块: 12个' },
                    { value: 15, text: '显示板块: 15个' },
                    { value: 20, text: '显示板块: 20个' }
                ],
                show_promotion_rate: 1,
                bans: [5, 4, 3, "炸"],
                plates: [{"name": "", "code": "8001"}],
                stocks_plate: {
                    "5": { "8001": [] },
                    "4": { "8001": [] },
                    "3": { "8001": [] },
                    "炸": { "8001": [] },
                },
            };
        },
        methods: {
            getNextTradingDay(dateStr) {
                if (!this.all_trading_days || this.all_trading_days.length === 0) return dateStr;
                const idx = this.all_trading_days.indexOf(dateStr);
                if (idx > -1 && idx < this.all_trading_days.length - 1) return this.all_trading_days[idx + 1];
                return dateStr;
            },
            initObserver() {
                if (this.observer) this.observer.disconnect();
                this.observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            const stockCode = entry.target.dataset.stockCode;
                            if (stockCode && !this.visibleStocks[stockCode]) {
                                this.$set(this.visibleStocks, stockCode, true);
                                this.observer.unobserve(entry.target);
                            }
                        }
                    });
                }, { rootMargin: '100px' });
                this.observeStockRows();
            },
            observeStockRows() {
                if (!this.show_min_chart) return;
                this.$nextTick(() => {
                    const rows = this.$el.querySelectorAll('.uplimit-min-chart-placeholder');
                    rows.forEach(row => {
                        if (row) this.observer.observe(row);
                    });
                });
            },
            show_sidebar(stock_info){
                this.$emit('show_sidebar',stock_info)
            },
            getBanPromotionStat(ban){
                const plateDict = this.stocks_plate && this.stocks_plate[ban]
                if(!plateDict) return ''
                const seen = new Set()
                let success = 0
                let total = 0
                Object.keys(plateDict).forEach(code => {
                    const arr = plateDict[code] || []
                    arr.forEach(item => {
                        const sc = item && item['stock_code']
                        if(!sc) return
                        if(seen.has(sc)) return
                        seen.add(sc)
                        total += 1
                        const pct = Number(item['next_close_pct'])
                        if(pct > 9.5) success += 1
                    })
                })
                if(total===0) return ''
                const rate = ((success / total) * 100).toFixed(0)
                return rate + '%'
            },
            click_show_up_success(){ this.update_info(this.date1); },
            onDatePicked(ctx) {
                this.date1 = ctx.selectedYMD;
                this.update_info(this.date1);
            },
            dateDisabled(ymd, date) {
                const weekday = date.getDay();
                if (this.last_trade_day && ymd === this.last_trade_day) return true;
                if (weekday === 0 || weekday === 6) return true;
                if (date.getTime() >= new Date().getTime()) return true;
                return false
            },
            real_time_info_stock(real_time_stocks,stock) {
                if(!real_time_stocks) return false;
                var fields = real_time_stocks['fields']
                var values = real_time_stocks['values']
                var idx = fields.indexOf(stock)
                if(idx > -1) return values[idx]
                return false
            },
            update_table_info(res,res2){
                let data = res['data']['data'];
                let plates = data['plate'];
                let plate_stocks = data['plate_stocks']
                let plate_arr = [];
                plates.forEach((item, idx) => {
                    if (idx >= this.show_top_n) return
                    plate_arr.push({ "name": item[0], "code": item[1], "score": item[2] })
                });
                this.plates = plate_arr;
                let ban_arr = [];
                for (let i = data.max_count; i > -1; i--) ban_arr.push(i);
                this.bans = ban_arr;
                let stocks_plate_dict = {};
                for (let idx in ban_arr) {
                    let ban = ban_arr[idx]
                    stocks_plate_dict[ban] = {}
                    plates.forEach((item) => {
                        let plate_code = item[1]
                        stocks_plate_dict[ban][plate_code] = []
                        let stocks_on_plate = plate_stocks[plate_code]
                        stocks_on_plate.forEach((item2) => {
                            if (item2['up_limit_keep_times'] == ban) {
                                if(this.status_market==1 && res2){
                                    let market = this.real_time_info_stock(res2['data']['data'],item2['stock_code']);
                                    item2['market']  = market;
                                }else{
                                    item2['market']  = {"px_change_rate":0,"open_px_rate":0}
                                }
                                stocks_plate_dict[ban][plate_code].push(item2)
                            }
                        })
                    });
                }
                this.stocks_plate = stocks_plate_dict;
            },
            update_info(date1) {
                request_zzquant({
                    url: 'v3/open/review/uplimit/hot?date1=' + date1+ '&limit=' + this.show_top_n,
                }).then(res => {
                    if(this.status_market==1){
                        let data = res['data']['data'];
                        if(data['stocks'] && data['stocks'].length > 0) {
                            request_zrx({ url: '/open/market/real?symbols='+data['stocks'] }).then(res2 => { this.update_table_info(res,res2); })
                        } else { this.update_table_info(res); }
                    }else{ this.update_table_info(res) }
                })
            }
        },
    }
</script>

<style scoped>
.uplimit-step-view {
    overflow-x: hidden;
    padding-bottom: 20px;
}

.control-item {
    margin: 4px;
    display: flex;
    align-items: center;
}

.ladder-scroll-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    background: var(--bg-main);
}

.ladder-grid {
    display: flex;
    flex-direction: column;
}

.ladder-header-col {
    width: 80px;
    min-width: 80px;
    flex-shrink: 0;
    padding: 4px 2px;
    font-size: 13px;
    font-weight: bold;
}

.ladder-content-cell {
    padding: 0 !important;
    min-width: 100px;
}

.ban-row {
    display: flex;
    align-items: baseline;
    justify-content: center;
    width: 100%;
}

.ban-number {
    font-size: 14px;
    color: #e33e33;
    font-weight: bold;
}

.small-count {
    font-size: 11px;
    color: #666;
    background: rgba(0,0,0,0.05);
    padding: 0 4px;
    border-radius: 3px;
    font-weight: normal;
}

body.theme-dark .small-count {
    color: #aaa;
    background: rgba(255,255,255,0.1);
}

.plate-name-badge {
    font-weight: bold;
    font-size: 13px;
    color: var(--text-main);
    padding: 0 2px;
}

.badge-success-outline {
    background: transparent;
    color: #28a745;
    border: 1px solid rgba(40, 167, 69, 0.5);
    font-size: 10px;
    padding: 0 4px;
    border-radius: 3px;
    margin-top: 2px;
}

.stock_item_block {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 13px;
    line-height: 1.4;
    color: var(--text-main);
    background-color: var(--bg-card);
    border-bottom: 1px solid rgba(0,0,0,0.05);
}

.mini-chart-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    background: var(--bg-muted);
}

.mini-chart-loading span {
    color: #999;
    font-size: 10px;
}

body.theme-dark .ladder-scroll-wrapper {
    border-color: #334155;
}

body.theme-dark .plate-name-badge {
    color: #f1f5f9;
}

@media (max-width: 768px) {
    .ladder-header-col {
        width: 65px;
        min-width: 65px;
        font-size: 12px;
    }
    .ban-number {
        font-size: 13px;
    }
    .ladder-content-cell {
        min-width: 90px;
    }
}
</style>
